import { useEffect, useRef, useState, useMemo } from 'react';
import mediaQuery from '../../../../../helpers/mediaQuery';

function useTranslateOnScroll(isOpen: boolean, innerWidth: number): void {
  const lastScrollTopRef = useRef(0);
  const [translateY, setTranslateY] = useState(0);
  const searchRef = useRef<HTMLElement>(document.getElementById('search-app'));
  const promoBarRef = useRef<HTMLDivElement>(document.querySelector('.page-header-promo-bar'));
  const isSmallOnly = useMemo(() => mediaQuery.isSmallOnly(), [innerWidth]);

  function scrollHandler(): void {
    if (isOpen) {
      return;
    }

    const searchHeight = searchRef.current?.offsetHeight || 0;
    const promoBarHeight = promoBarRef.current?.offsetHeight || 0;
    const isScrollBeforeThreshold = window.pageYOffset <= promoBarHeight + searchHeight;
    const isScrollScrollUp = window.pageYOffset < lastScrollTopRef.current;
    setTranslateY(isScrollBeforeThreshold || isScrollScrollUp ? 0 : -searchHeight);
    lastScrollTopRef.current = window.pageYOffset;
  }

  useEffect(() => {
    if (isSmallOnly) {
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [innerWidth]);

  useEffect(() => {
    if (isSmallOnly) {
      searchRef.current?.style.setProperty('transition', 'transform 200ms ease');
      searchRef.current?.style.setProperty('transform', `translateY(${isOpen ? 0 : translateY}px)`);
      searchRef.current?.style.setProperty('z-index', `${isOpen ? 1 : -1}`);
    } else {
      searchRef.current?.style.removeProperty('transition');
      searchRef.current?.style.removeProperty('transform');
      searchRef.current?.style.removeProperty('z-index');
    }
  }, [translateY, innerWidth, isOpen]);
}

export default useTranslateOnScroll;
